import { t as defaultT } from "i18next";

export const getErrorMessageFromErrorResponse = (error, t = defaultT) => {
  let message = "";

  if (error.response?.data) {
    const { message: serverMessage, i18nKey } = error.response.data;

    if (i18nKey) {
      const translated = t(`${i18nKey}.text`, {
        defaultValue: serverMessage,
      });
      message = translated || serverMessage;
    } else {
      message = serverMessage;
    }
  } else {
    message = error.message;
  }

  return message;
};
